<p-confirmPopup key="invitationConfirmation"></p-confirmPopup>

<p-messages *ngIf="!loading && viewModel.logs?.length === 0" severity="info">
	<ng-template pTemplate>
		<span class="p-message-icon pi pi-info-circle"></span>
		<span id="no-logs-message">You don't currently have any logs.</span>

		<button pButton label="Click here to create one!" class="p-button-raised p-button-rounded p-button-sm" (click)="onCreateLogClicked()"></button>
	</ng-template>
</p-messages>

<div *ngIf="loading || viewModel.logs?.length" class="p-table-container">
	<p-table #table id="log-list"
	    stateStorage="local"
	    [stateKey]="getStateKey()"
		[globalFilterFields]="filterList"
		[value]="viewModel.logs"
		[rowHover]="true" [loading]="loading" sortMode="multiple"
		styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
		[scrollable]="true" scrollHeight="flex">

		<ng-template pTemplate="caption">
			<div class="p-d-flex">
				<!-- Column Picker Cog & Menu -->
				<button pButton icon="pi pi-cog" (click)="actions.toggle($event)"
					class="p-button-rounded p-button-secondary p-button-text min-max-button">
				</button>

				<p-overlayPanel #actions appendTo="body">
					<ng-template pTemplate>
						<ng-container *ngFor="let column of columns | keyvalue">
							<div *ngIf="column.key != 'name'" class="p-field-checkbox">
								<label>
									<p-checkbox [binary]="true" [inputId]="column.key" [(ngModel)]="columns[column.key]" 
										(ngModelChange)="onColumnsChanged()">
									</p-checkbox>
	
									Show {{camel2Title(column.key)}}
								</label>
							</div>
						</ng-container>
					</ng-template>
				</p-overlayPanel>

				<span class="p-input-icon-left p-ml-auto">
					<i class="pi pi-search"></i>
					<input pInputText type="text" (input)="filterTable(table, $event)" [(ngModel)]="searchFilter" placeholder="Search keyword" />
				</span>
			</div>
		</ng-template>

		<ng-template pTemplate="colgroup">
			<colgroup>
				<col *ngFor="let column of visibleColKeys" 
					[ngClass]="{ wider: ['description', 'name'].includes(column) }">
			</colgroup>
		</ng-template>

		<ng-template pTemplate="header">
			<tr>
				<th *ngFor="let column of visibleColKeys" [pSortableColumn]="column">
					<div class="p-d-flex p-ai-center">
						{{column == 'name' ? 'Log' : camel2Title(column)}}
						<p-sortIcon [field]="column"></p-sortIcon>
						
						<p-columnFilter [field]="column" type="{{column.endsWith('DateTime') ? 'date' : 'text'}}" 
							display="menu" class="p-ml-auto">
						</p-columnFilter>
					</div>
				</th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-log let-rowIndex="rowIndex">
			<tr *ngIf="rowIndex === 0 && viewModel.unverifiedEmails">
                <td [colSpan]="columns.length">
                    <p-messages severity="warn">
						<ng-template pTemplate>
							<span class="p-message-icon pi pi-exclamation-triangle"></span>
							
							<span [innerHtml]="viewModel.unverifiedEmails"></span>
						</ng-template>
					</p-messages>
                </td>
			</tr>
			
			<tr>
				<td>
					<div *ngIf="!log.logInvitationId; else invitations">
						<span *ngIf="!isForceLogAdmin() && log.paymentStatus === 'Payment Expired'">
							{{log.name}}
							<span *ngIf="!columns['paymentStatus']" class="custom-badge danger">{{log.paymentStatus}}</span>
						</span>

						<a *ngIf="isForceLogAdmin || log.paymentStatus !== 'Payment Expired'" (click)="selectLog(log)">
							{{log.name}}
							<span *ngIf="log.paymentStatus === 'Payment Expires Soon' && !columns['paymentStatus']" class="custom-badge warning">{{log.paymentStatus}}</span>
							<span *ngIf="log.logStatus === 'Scheduled For Deletion' && !columns['logStatus']" class="custom-badge danger">{{log.logStatus}}</span>
						</a>
					</div>

					<ng-template #invitations>
						<div class="invitation-container p-d-flex p-ai-center p-jc-between p-flex-wrap">
							<span>{{log.name}}</span>

							<div class='invitation-buttons'>
								<button pButton label="Accept" (click)="confirmInvitationResponse($event, log, true)" class="p-button-raised p-button-rounded p-button-sm p-button-info"></button>
								<button pButton label="Reject" (click)="confirmInvitationResponse($event, log, false)" class="p-button-raised p-button-rounded p-button-sm p-button-danger"></button>
							</div>
						</div>
					</ng-template>
				</td>

				<td *ngIf="columns['description']">{{log.description}}</td>

				<td *ngIf="columns['logOwner']">{{log.logOwner}}</td>

				<td *ngIf="columns['logStatus']">
					<ng-container [ngSwitch]="log.logStatus">
						<span *ngSwitchCase="'Pending Invitation'" class="custom-badge warning">{{log.logStatus}}</span>
						<span *ngSwitchCase="'Scheduled For Deletion'" class="custom-badge danger">{{log.logStatus}}</span>
						<span *ngSwitchDefault class="custom-badge info">{{log.logStatus}}</span>
					</ng-container>
				</td>

				<td *ngIf="columns['paymentStatus']">
					<ng-container *ngIf="!log.logInvitationId" [ngSwitch]="log.paymentStatus">
						<span *ngSwitchCase="'Payment Expired'" class="custom-badge danger">{{log.paymentStatus}}</span>
						<span *ngSwitchCase="'Payment Expires Soon'" class="custom-badge warning">{{log.paymentStatus}}</span>
						<span *ngSwitchDefault class="custom-badge success">{{log.paymentStatus}}</span>
					</ng-container>
				</td>

				<td *ngIf="columns['lastNoteDateTime']"><span>{{log.lastNoteDateTime | date:'MM/dd/yyyy HH:mm'}}</span></td>

				<td *ngIf="columns['paymentExpiresDateTime']"><span>{{log.paymentExpiresDateTime | date:'MM/dd/yyyy HH:mm'}}</span></td>
			</tr>
		</ng-template>
	</p-table>
</div>